// extracted by css-extract-rspack-plugin
module.exports =  {"root":"BookkeepingManager__root___a8bFW"};